<template>
  <div>
    <div style=" font-size: 18px;padding-bottom: 20px;    text-align: center;">选择客户</div>
    <a-form-model :colon="false">
      <a-form-model-item label="客户名称">
        <a-row :gutter="20">
          <a-col :span="20">
            <a-input v-model="customerName" auto-complete="off" placeholder="请输入客户名称" clearable></a-input>
          </a-col>
          <a-col :span="4">
            <a-button @click="search">查询</a-button>
          </a-col>
        </a-row>
      </a-form-model-item>
    </a-form-model>
    <a-table
      :table-loading="table.loading"
      :data-source="table.data"
      :pagination="table.pagination"
      @change="handleTableChange"
      ref="table.dataRef">
      <a-table-column
        :sorter="true"
        key="name"
        data-index="name" title="客户名称" width="120">
      </a-table-column>
      <a-table-column
        :sorter="true"
        key="number"
        data-index="number" title="IFS No." width="70">
      </a-table-column>
      <a-table-column title="操作" fixed="right">
        <template slot-scope="text, record">
          <a-button type="link" @click="bindMan(record)" :disabled="record.isConnect === 1">{{record.isConnect === 1?'已绑定':'绑定'}}
          </a-button>
        </template>
      </a-table-column>
    </a-table>

  </div>

</template>

<script>
import {_queryBizCompanyList} from '../../../api/bizCompanyApi';
import {findSalesmanCompany, getSalesmanCompanyData, saveSalesmanCompany} from '../../../api/salesman';

async function getSalesmanCompany() {
  // let treeData = [{
  //   title: '公司名',
  //   key: 'company',
  //   children: []
  // }]
  // this.treeData = treeData;
  // this.companyData = [];
  // const result = await _queryBizCompanyList();
  // //
  // if (result.code === 1200) {
  //   this.companyData = result.data.bizCompanys;
  //   let length = result.data.bizCompanys.length;
  //   for (let i = 0; i < length; i++) {
  //     //   title: this.companyData[i].name + this.companyData[i].number,
  //     //   key: this.companyData[i].id
  //     // })
  //     this.treeData[0].children.push({
  //       title: this.companyData[i].name + this.companyData[i].number,
  //       key: this.companyData[i].id
  //     })
  //   }
  //   const tree = await findSalesmanCompany(this.form.data.id);
  //   if (tree.code === 1200) {
  //     const res = tree.data.bizSalesmanCompanys;
  //     // this.selectedKeys.push()
  //     res.forEach((x) => {
  //       this.checkedKeys.push(x.id);
  //       // this.treeData.push(x.id);
  //     });
  //     //   this.$nextTick(() => {
  //     //     this.$refs.tree.setCheckedKeys(this.treeData);// 获取已经设置的资源后渲染
  //     //   });
  //   }
  // }
  const result = await getSalesmanCompanyData(this.form.data.id, {
    page: this.table.pagination.current,
    size: this.table.pagination.pageSize,
    name: this.customerName
  });
  if (result.code === 1200) {
    this.table.data = result.data.bizSalesmanCompanys;
    this.table.pagination.total = result.data.total;
  };
}

async function bindMan(row) {
  const res = await saveSalesmanCompany(this.form.data.id, row.id);
  if (res.code === 1200) {
    this.$message.success('商务人员绑定成功');
    this.getSalesmanCompany();
  } else {
    this.$message.error('商务人员绑定失败');
  }
}

function search() {
  this.table.pagination.current = 1;
  this.getSalesmanCompany();
}

function save() {

  // const res = saveSalesmanCompany(this.form.data.id, this.customerName);
  // if (res.code === 1200) {
  //   this.$message.success('商务人员绑定成功');
  // } else {
  //   this.$message.error('商务人员绑定失败');
  // }
  this.form.data = {};
  this.customerName = '';

}

function cancel() {
  this.form.data = {};
  this.customName = '';

}

function handleTableChange(pagination, filters, sorter) {
  this.table.pagination.current = pagination.current;
  this.table.pagination.pageSize = pagination.pageSize;
  this.getSalesmanCompany();
}

export default {
  name: 'SalesmanCompany',
  props: {
    salesmanId: String,
    onSaveHandler: Function,
    onCancelHandler: Function,
  },
  data() {
    return {
      customerName: '',
      companyIds: '',
      form: {
        data: {
          id: '',
          name: '',
          companyId: '',
        },
      },
      formRules: {},
      table: {
        loading: false,
        data: [],
        pagination: {
          current: 1,
          pageSize: 10,
          total: 0,
          showSizeChanger: true,
          pageSizeOptions: ['10', '20', '40', '50'],
          showTotal: (total, range) => `${ range[0] }-${ range[1] } of ${ total } items`,
        },
      },
    };
  },
  created() {
    this.form.data.id = this.salesmanId;
    this.getSalesmanCompany();
  },
  methods: {
    save,
    search,
    cancel,
    getSalesmanCompany,
    handleTableChange,
    bindMan
  },
  computed: {
  },
};
</script>

<style scoped>

</style>
